document.addEventListener("DOMContentLoaded", function () {
  console.log("DOM content loaded");
  (function ($) {
    // Astute chatbot passive loader
    $(".chatbot-container").on("click", function () {
      let self = $(this);

      let astuteOnLoad = function () {
        astuteBotLauncher.init({
          secondsBeforeDisplaying: 0,
          chatInitiallyVisible: false,
          hideLauncherButtonWhenChatVisible: true,
          toggleChatMarkup: "",
          titleMarkup: "Welcome to Estroven!",
          autoGetStarted: true,
          conversationServiceId: "",
          persistConversationAcrossSession: true,
          wasClosed: true,
          fullScreenMobile: !1,
          allowMicrophone: !1,
          replyHeightPixels: 36,
          botUrl: window.astuteBotMessengerSettings.channelId,
        });

        // wait for Astute messenger js to load
        // there's no callback for the astuteBotLauncher implementation
        setTimeout(function () {
          // remove our temporary icon
          self.remove();

          // display chat after clicked
          astuteBotLauncher.showChat();
        }, 750);
      };

      scriptLoad(
        window.astuteBotMessengerSettings.chatbot,
        "astutebot-messenger",
        astuteOnLoad
      );
    });

    $(".video-section__media .deferred-media__poster-button").click(
      function () {
        $(".video_main_bar").removeClass("video_show");
        $(this)
          .closest("deferred-media")
          .find(".video_main_bar")
          .addClass("video_show");
        $("body").removeClass("video_show_layout");
        $("body").addClass("video_show_layout");
        $(this).addClass("Youtube_video");

        var $this = $(this);
        var videoUrl = $(this).data("video_url");
        var videoUrl = $(this)
          .closest("deferred-media")
          .find("iframe")
          .attr("src");
        var videoUrl = $("#myPopup").find("iframe").attr("src");
        console.log(videoUrl);
        var modalHtml =
          '<div class="modal-container">' +
          '<div class="modal-content">' +
          '<span class="close">&times;</span>' +
          '<iframe src="' +
          videoUrl +
          '" frameborder="0" allowfullscreen></iframe>' +
          "</div>" +
          "</div>";
        $($this).closest("deferred-media").find(".Video_bar").html(modalHtml);
        $(".close").click(function () {
          $("body").removeClass("video_show_layout");
          $(".modal-container").remove();
        });
      }
    );
  })(jQuery);
});

/* Replace ® to <sup>®</sup>  product__title */
document.addEventListener("DOMContentLoaded", function (e) {
  if (document.querySelector(".product__title h1") != null) {
    let productTitle = document.querySelector(".product__title h1").innerHTML;
    if (productTitle.includes("<sup>®</sup>")) {
      document.querySelector(".product__title h1").innerHTML =
        productTitle.replace("<sup>®</sup>", "<sup>®</sup>");
    } else {
      document.querySelector(".product__title h1").innerHTML =
        productTitle.replace("®", "<sup>®</sup>");
    }
  }

  const card_heading = document.querySelectorAll("h3.card__heading a");
  if (card_heading.length) {
    for (let i = 0; i < card_heading.length; i++) {
      let card_title = card_heading[i].innerHTML;
      if (card_title.includes("<sup>®</sup>")) {
        card_heading[i].innerHTML = card_title.replace(
          "<sup>®</sup>",
          "<sup>®</sup>"
        );
      } else {
        card_heading[i].innerHTML = card_title.replace("®", "<sup>®</sup>");
      }
    }
  }
});

// js for about page (click leaf title & scroll down to its section)
$(document).ready(function (e) {
  $("a.common_scroll").on("click", function (event) {
    event.preventDefault();
    let section = $(this).attr("href");
    if (section !== "") {
      $("html, body").animate(
        {
          scrollTop: $(section).offset().top,
        },
        800,
        function () {
          //window.location.hash = hash;
        }
      );
    }
  });

  /* cart product flip :Start */
  $(".flip_back").click(function () {
    $(this)
      .closest(".flips-box-product-card")
      .find(".flips-box-card")
      .addClass("is-flipped");
  });
  $(".flip_box_reverse").click(function () {
    $(this)
      .closest(".flips-box-product-card")
      .find(".flips-box-card")
      .removeClass("is-flipped");
  });

  $(".purchase_sub_option").click(function () {
    $(".purchase_sub_option").removeClass("active");
    $(this).addClass("active");
    var plan_name = $(this).find(".option_input").data("sub_pan");

    if (typeof plan_name !== "undefind" && plan_name != "") {
      if (plan_name == "one_time") {
        $(this).closest(".subscription-product").find(".selling_plan").val(" ");
        $(this)
          .closest(".form")
          .find(".add_to_card_price")
          .html($(this).find(".option_input").data("plan_price"));
      } else {
        let sell_ID = $(this).find(".option_input").attr("id");
        $(this)
          .closest(".subscription-product")
          .find(".selling_plan")
          .val(sell_ID);
        $(this)
          .closest(".form")
          .find(".add_to_card_price")
          .html($(this).find(".option_input").data("plan_price"));
      }
    }
  });

  /* cart product flip : End */
});

$(document).ready(function () {
  $(".desktop_flips_box").slick({
    dots: true,
    arrows: false,
    infinite: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
});

$(document).ready(function () {
  let debounceTimer;

  setInterval(function () {
    let cartRedeemFreeGift = parseFloat(
      $(".cart-redeem-free-gift").attr("data-total-price")
    );
    let cartTotalPrice = parseFloat(
      $(".drawer__footer").attr("total-cart-price")
    );

    function getPaidProductQuantity() {
      let paidProductQuantity = 0;
      $(".cart-items .cart-item").each(function () {
        // Check if the product is a paid product (not a free gift)
        if (!$(this).hasClass("redeem-product-item")) {
          paidProductQuantity += parseInt($(this).find(".quantity__input").val()) || 0;
        }
      });
      return paidProductQuantity;
    }

    function getFreeProductQuantity() {
      let freeProductQuantity = 0;
      $(".cart-items .cart-item.redeem-product-item").each(function () {
        freeProductQuantity += parseInt($(this).find(".quantity__input").val()) || 0;
      });
      return freeProductQuantity;
    }

    function adjustFreeRedeemProductsQuantity() {
      let paidQuantity = getPaidProductQuantity();
      let freeQuantity = getFreeProductQuantity();

      if (freeQuantity > paidQuantity) {
        let excessQuantity = freeQuantity - paidQuantity;

        $(".redeem-product-item").each(function () {
          let quantity = parseInt($(this).find(".quantity__input").val()) || 0;
          if (quantity > excessQuantity) {
            for (let i = 0; i < excessQuantity; i++) {
              $(this).find('.quantity__button[name="minus"]').click();
            }
          }
        });
      }
    }

    function toggleFreeRedeemProducts() {
      let paidQuantity = getPaidProductQuantity();
      let freeQuantity = getFreeProductQuantity();

      if (freeQuantity >= paidQuantity) {
        $(".free-product-heading")
          .html($(".free-product-heading").attr("data-sucess"))
          .addClass("product_redeemed");
        $(".cart-redeem-free-gift .reddem-free-gift").hide();
      } else {
        $(".cart-redeem-free-gift").show();
      }
    }

    function debounce(fn, delay) {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(fn, delay);
    }

    debounce(function () {
      toggleFreeRedeemProducts();
      adjustFreeRedeemProductsQuantity();
    
      var freeGiftHandles = [];
      $(".redeem-free-gift .freeGiftHandle").each(function () {
        freeGiftHandles.push($(this).val());
      });
    
      $(".cart-items .cart-item").each(function () {
        var productHandle = $(this)
          .find(".cart-item__details")
          .attr("data-product-handle");
    
        if (freeGiftHandles.includes(productHandle)) {
          $(this).addClass("redeem-product-item");
          $(".cart-items")
            .find(".cart-item__quantity-wrapper")
            .addClass("redeem-free-gift-wrapper");
          $(this).find(".product-subscription-section").remove();
          $(this).find(".free-color").remove();
          $(this).find(".quantity__button").css("visibility", "hidden");
          $(this)
            .find(".cart-item__quantity-wrapper .cart-item__totals")
            .before('<p class="free-color">Free Gift</p>');
        }
    
        if ($(this).find(".discount-message").length) {
          $(this).addClass("bundle-product");
        } else {
          $(this).removeClass("bundle-product");
        }
      });
    
      let paidProductQuantity = getPaidProductQuantity();
      let redeemProductQuantity = getFreeProductQuantity();
    
      if (paidProductQuantity === 0 && redeemProductQuantity > 0) {
        $(".redeem-product-item .cartDrawer_Remove").last().click();
      }
    }, 500);
  }, 1000);
});



// setInterval(() => {

//   const allRows = document.querySelectorAll('.cart-items tbody tr');
//   const redeemRows = document.querySelectorAll('.cart-items tbody tr.redeem-product-item');
//   const giftcardRows = document.querySelectorAll('.cart-items tbody tr.giftcard_product');
//   const cartRows = document.querySelectorAll('.cart-items tbody tr:not(.redeem-product-item):not(.giftcard_product)');

//   if (redeemRows.length >= 1 && giftcardRows.length >= 1 && cartRows.length === 0) {
//     redeemRows[0].classList.add('wps-btn-checkout');
//     redeemRows.forEach(row => {
//       const removeButton = row.querySelector('.cartDrawer_Remove');
//       if (removeButton) {
//         removeButton.click();
//       }
//     });
//   }
// }, 1000);

$(document).ready(function (e) {
  document.addEventListener("start", () => {
    getRecomandProduct();
  });

  function getRecomandProduct() {
    $.getJSON("/cart.js", function (cart) {
      if (cart.item_count > 0) {
        let item_ids = [];
        let item_added = 0;
        $(cart.items).each(function (i, item) {
          item_ids.push(item.product_id);
        });

        $(cart.items).each(function (i, item) {
          if (item_added < 2) {
            fetch(
              window.Shopify.routes.root +
                "recommendations/products.json?product_id=" +
                item.product_id +
                "&limit=4&intent=related"
            )
              .then((response) => response.json())
              .then(({ products }) => {
                if (products.length > 0) {
                  $(products).each(function (indx, product) {
                    if (!item_ids.includes(product.id) && item_added < 2) {
                      var productTileTemplateUrl =
                        "/products/" + product.handle + "?view=product-card";

                      var resultPromise = fetch(productTileTemplateUrl).then(
                        function (res) {
                          return res.text();
                        }
                      );

                      resultPromise
                        .then(function (response) {
                          if (response && response.trim() != "") {
                            $(".cartRecomendationProduct").append(
                              response.trim()
                            );

                            $(
                              ".cartRecomendationProduct button[type=submit]"
                            ).addClass("cart-upsell");
                          }
                        })
                        .catch(function (error) {
                          addErrorStyles(
                            "Failed to perform search. Check your internet connection and try again."
                          );
                        });

                      item_added++;
                    }
                  });
                }
              });
          }
        });
      } else {
        var collectionProductList = "/collections/all?view=products";

        var cProductPromise = fetch(collectionProductList).then(function (res) {
          return res.text();
        });
        cProductPromise
          .then(function (response) {
            if (response && response.trim() != "") {
              $(".cartRecomendationProduct").append(response.trim());
            }
          })
          .catch(function (error) {
            addErrorStyles(
              "Failed to perform search. Check your internet connection and try again."
            );
          });
      }
    });
  }
});